export { getDeviceActionString } from './getDeviceActionString';
export { getNumberDevicesString } from './getNumberDevicesString';
export { setActivityHistoryDetailsQueryString } from './setActivityHistoryDetailsQueryString';
export { setActivityTableQueryString } from './setActivityTableQueryString';
export { setDeviceTableQueryString } from './setDeviceTableQueryString';
export { translateDeviceAction } from './translateDeviceAction';
